import * as React from "react";
import { Card, Tag } from "antd";
import { CardTitle } from "../../../components/antd/card/CardTitle";
import { CardContent } from "../../../components/antd/card/CardContent";
import { useAppSelector } from "../../../store/hooks";
import { selectOrg } from "../../../store/contextSlice";
import { selectOrgs } from "../../../store/userDataSlice";
import { CpFormItem } from "../testNewForm/CpFormItem";
import { CpLabel } from "../testNewForm/CpLabel";
import { CpErrorWarning } from "../testNewForm/CpErrorWarning";
import { CpRadioCardGroup } from "../testNewForm/CpRadioCardGroup";
import { CpLabelTooltip } from "../testNewForm/CpLabelTooltip";
import { CpTooltip } from "../testNewForm/CpTooltip";

interface Props {}
export const EndpointNamingFormat: React.FC<Props> = ({}) => {
  const org = useAppSelector(selectOrg);
  const orgs = useAppSelector(selectOrgs);

  return (
    <>
      <div className="cpln-form-section cpln-ant-card-container">
        <Card>
          <CardTitle>
            <div className={`flex items-center`}>
              <div>Endpoint Naming Format</div>
              <div className="flex-grow" />
            </div>
          </CardTitle>
          <CardContent>
            <CpFormItem>
              <CpLabelTooltip>
                <CpLabel name={`endpointNamingFormat`}>Endpoint Naming Format</CpLabel>
                <CpTooltip
                  tooltipProps={{
                    title: (
                      <div>
                        <div>Customizes the subdomain format for the canonical workload endpoint</div>
                        {orgs.find((o) => o.name === org)?.status?.endpointPrefix ? (
                          <div>
                            Org Endpoint Prefix for the current org:{" "}
                            {orgs.find((o) => o.name === org)?.status?.endpointPrefix}
                          </div>
                        ) : null}
                      </div>
                    ),
                  }}
                />
              </CpLabelTooltip>
              <CpRadioCardGroup
                name={`endpointNamingFormat`}
                options={[
                  {
                    label: "Org",
                    value: "org",
                    boldLabel: true,
                    children: (
                      <div className="mt-2">
                        <Tag className="font-mono">{`<workloadName>-<gvcName>.<orgEndpointPrefix>.cpln.app`}</Tag>
                      </div>
                    ),
                  },
                  {
                    label: "Legacy",
                    value: "legacy",
                    boldLabel: true,
                    children: (
                      <div className="mt-2">
                        <Tag className="font-mono">{`<workloadName>-<gvcName>.cpln.app`}</Tag>
                      </div>
                    ),
                  },
                ]}
              />
              <CpErrorWarning name={`endpointNamingFormat`} />
            </CpFormItem>
          </CardContent>
        </Card>
      </div>
    </>
  );
};
